import {Integration} from '../../../models';
import config from '../../../../config';
import {defaultContentOptions} from '../constants';
import {EmailContentOptions} from './types';

export const DEFAULT_MERGE_TAGS: any[] = [
  {
    title: 'Date',
    menu: [
      {title: 'Date YYYY-MM-DD', value: 'utils.ds'},
      {title: 'Date Yesterday YYYY-MM-DD', value: 'utils.ds_yesterday'},
      {
        title: 'Date Custom Format',
        value: "utils.ds | date_format('Today is %d, %b %Y')",
      },
    ],
  },
  {
    title: 'User',
    menu: [
      {title: 'User Email', value: 'utils.user_email'},
      {title: 'User First Name', value: 'utils.user_first_name'},
      {title: 'User Last Name', value: 'utils.user_name'},
    ],
  },
];

export const defaultSmtpIntegration: Integration = {
  uid: 'default',
  name: 'Default Pushmetrics SMTP Integration',
  type: 'smtp',
  encrypted_config: '',
  config: '',
  created_on_utc: '2021-07-07T14:00:00.000Z',
  changed_on_utc: '2021-07-07T14:00:00.000Z',
  changed_by: {
    id: 'default',
    uid: 'default',
    first_name: 'default',
    last_name: 'default',
    email: 'default@example.com'
  },
  created_by: {
    id: 'default',
    uid: 'default',
    first_name: 'default',
    last_name: 'default',
    email: 'default@example.com'
  },
  reports: [],
  config_json: {
    email_addresses: [
      {
        name: `${config.app.default_email_sender_name}`,
        value: `${config.app.default_email_from}`
      }
    ]
  }
};

export const emailContentOptions: EmailContentOptions = {
  ...defaultContentOptions,
  showMergePdf: true,
  showDownloadAttachments: false,
  showMergeCsv: true,
};
